import Overview from '@rebuild/materials/shared/quarterly_performance/Overview.vue';
import BaseFull from '@rebuild/materials/shared/quarterly_performance/BaseFull.vue';
import { withProvider } from '@rebuild/hooks/useCompWithProvider';
import { provideCurrentContext } from '@rebuild/materials/shared/quarterly_performance/context';
import i18n from '@/assets/js/i18n';

function useSelfContext() {
	provideCurrentContext({
		getPerformanceContentTitle: prop => {
			if (prop === 't1') {
				return i18n.t('enterprise.page-version');
			}
			if (prop === 't2') {
				return i18n.t('enterprise.earnings-library--btn');
			}
		}
	});
}

export const componentMap = {
	overview: withProvider(Overview, useSelfContext),
	full: withProvider(BaseFull, useSelfContext)
};
